import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PAGE_TITLE_PREFIX } from '@smarsh-cyber/shared/constants';
@Injectable()
export class PageTitleStrategyService extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      this.title.setTitle(`${PAGE_TITLE_PREFIX} | ${title}`);
    } else {
      this.title.setTitle(`${PAGE_TITLE_PREFIX}`);
    }
  }
}
